/**
 * Included into the footer of pages.
 */

import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

//@ts-ignore
var StickyNav = require('./component/StickyNav.js');
StickyNav.init();



// ============================================================================================== //
// Site Animations -> InViewObserver.ts
// ============================================================================================== //
import InViewObserver from './component/InViewObserver';
InViewObserver.createInstance([
	{
		observeSelector: '.introBlock, .buildingListing, .callToAction, .residentListing, .peopleListing, .wp-block-group, .resident, .building, .wpcp-carousel-wrapper, .richContent, .video-blocks',
		minimum: 20,
		minimumUnit: "px"
	}
]);
// ---------------------------------------------------------------------------------------------- //



// ============================================================================================== //
// Controls Home Page Video
// ============================================================================================== //
function checkAndUpdateClass() {
	const element = document.querySelector('.video-blocks');
	const video = document.getElementById('mastheadVideo') as HTMLVideoElement;
	if (!video) {
		return;
	}
	const block7  = document.querySelector('.video-blocks .block[data-item="7"] .imageWrapper');
	const block8  = document.querySelector('.video-blocks .block[data-item="8"] .imageWrapper');
	const block9  = document.querySelector('.video-blocks .block[data-item="9"] .imageWrapper');

	// Set the video to loop
	// video.loop = true;

	// Check if video has ran through the first time, then add class and restart.
	video.addEventListener('ended', function() {
		element.classList.add('video-finished');
		this.play();
	});

	// Moves the video from one location to another based on browser size.
	function moveVideo() {
		if (window.innerWidth <= 600) {
			video.parentNode.removeChild(video);
			block9.appendChild(video);
		} else if (window.innerWidth <= 1200) {
			video.parentNode.removeChild(video);
			block8.appendChild(video);
		} else {
			video.parentNode.removeChild(video);
			block7.appendChild(video);
		}
	}

	window.addEventListener('resize', moveVideo);
	moveVideo();
}

checkAndUpdateClass();
// ---------------------------------------------------------------------------------------------- //



// ============================================================================================== //
// Masthead Gallery/Collage
// ============================================================================================== //
$( document ).on('ready', function() {
	var displayedImages: any = [];
	var storedImages: any = [];
	var oldActive = '';
	var newActive = '';

	function initArray() {
		var images: any = $('.gallery .image-blocks .block img.active');

		for (var i = 0; i < images.length; i++) {
			if (i <= 14) {
				displayedImages.push($(images[i]).attr("src"));
			} else {
				storedImages.push($(images[i]).attr("src"));
			}
		}
	}

	initArray();

	function generateRandom(min: any, max: number, excluded: any) {
		var num = Math.floor(Math.random() * (max-min) + min);
		if (num === excluded) num++;
		return num;
	}

	function updateArrays(itemFromDisplay: string, itemDisplayPosition: number, itemFromStorage: string, itemStoragePosition: number) {
		displayedImages.splice(itemDisplayPosition, 1);
		displayedImages.splice(itemDisplayPosition, 0, itemFromStorage);
		storedImages.splice(itemStoragePosition, 1);
		storedImages.push(itemFromDisplay);
	}

	function changeSrc() {
		// Where you see 15 below was 10 when the First & First logo was in the lower left corner (or 10th position) in the collage.
		var randomDisplayedNum = generateRandom(0, displayedImages.length, 15);
		var randomStoredNum = generateRandom(0, storedImages.length - 15, 15);
		// var randomStoredNum = 0;

		var doesImageAlreadyExist = displayedImages.includes(storedImages[randomStoredNum]);

		if (doesImageAlreadyExist) {
			changeSrc();
		} else {
			var cells = $(".gallery .image-blocks .block");
			var cell = cells.eq(randomDisplayedNum);

			cell.find("img").each(function(index) {
				if ($(this).hasClass("active")) {
					oldActive = $(this).attr("src");
					$(this).removeClass("active");
				} else {
					$(this).addClass("active");
					$(this).attr("src", storedImages[randomStoredNum]);
					newActive = $(this).attr("src");
				}
			});

			cell.find("img").fadeToggle(1800);

			updateArrays(oldActive, randomDisplayedNum, newActive, randomStoredNum);
		}
	};

	setInterval(function() {
		changeSrc();
	}, 2000);
});
// ---------------------------------------------------------------------------------------------- //



// ============================================================================================== //
// Accordion Functionality
// ============================================================================================== //
const availableMenu = $(".footerMenu");

if(availableMenu.length !== 0) {
	// On Page Load - Close all accoridons
	const firstActiveMenu = availableMenu.find('.nav');

	for (let i = 0; i < firstActiveMenu.length; i++) {
		$(firstActiveMenu[i]).removeClass("active").slideUp(0);
	}

	// Listeners
	$('.pageFooter .pageFooter__upperRight .container').on( "click" , function( event ) {
		const labelId = $(this).attr('data-label-id');
		availableMenu.trigger("changeActive", {labelId});

		console.log('Clicked!');
	});

	// Triggers
	// Updates 'Active' Menu
	availableMenu.on( "changeActive" , function(event, data) {
		const updateActiveMenu = availableMenu.find(".nav");

		window.scrollTo(0, document.body.scrollHeight);

		for (let i = 0; i < updateActiveMenu.length; i++) {
			if (data.labelId === updateActiveMenu[i].dataset.labelId) {
				if ($(updateActiveMenu[i]).hasClass("active")) {
					$(updateActiveMenu[i]).removeClass("active").slideUp();
				} else {
					$(updateActiveMenu[i]).addClass("active").slideDown();
				}
			} else {
				$(updateActiveMenu[i]).removeClass("active").slideUp();
			}
		}
	});
}
// ---------------------------------------------------------------------------------------------- //